import { render, staticRenderFns } from "./TextTwoColumnsWithImage.vue?vue&type=template&id=2e3d1792"
import script from "./TextTwoColumnsWithImage.vue?vue&type=script&lang=js"
export * from "./TextTwoColumnsWithImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports